/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePaymentMethodRequest
 */
export interface UpdatePaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentMethodRequest
     */
    paymentMethodId: string;
}

/**
 * Check if a given object implements the UpdatePaymentMethodRequest interface.
 */
export function instanceOfUpdatePaymentMethodRequest(value: object): value is UpdatePaymentMethodRequest {
    if (!('paymentMethodId' in value) || value['paymentMethodId'] === undefined) return false;
    return true;
}

export function UpdatePaymentMethodRequestFromJSON(json: any): UpdatePaymentMethodRequest {
    return UpdatePaymentMethodRequestFromJSONTyped(json, false);
}

export function UpdatePaymentMethodRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePaymentMethodRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethodId': json['paymentMethodId'],
    };
}

export function UpdatePaymentMethodRequestToJSON(json: any): UpdatePaymentMethodRequest {
    return UpdatePaymentMethodRequestToJSONTyped(json, false);
}

export function UpdatePaymentMethodRequestToJSONTyped(value?: UpdatePaymentMethodRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethodId': value['paymentMethodId'],
    };
}

